import type { GetListParams } from "ra-core";

/**
 * Normalize a list search `q` so ra-data-postgrest treats it as one ILIKE token.
 * That library splits on whitespace and breaks PostgREST filters from the 3rd word
 * onward; replacing spaces with `%` keeps phrase search working without that path.
 */
export function normalizeFullTextQuery(q: string): string | null {
  const trimmed = q.trim();
  if (!trimmed) return null;
  return trimmed.replace(/\s+/g, "%");
}

export const applyFullTextSearch =
  (columns: string[]) => (params: GetListParams) => {
    if (!params.filter?.q) {
      return params;
    }
    const { q, ...filter } = params.filter;
    const normalized = normalizeFullTextQuery(String(q));
    if (!normalized) {
      return { ...params, filter };
    }
    return {
      ...params,
      filter: {
        ...filter,
        "@or": columns.reduce(
          (acc, column) => {
            if (column === "email")
              return {
                ...acc,
                [`email_fts@ilike`]: normalized,
              };
            if (column === "phone")
              return {
                ...acc,
                [`phone_fts@ilike`]: normalized,
              };
            return {
              ...acc,
              [`${column}@ilike`]: normalized,
            };
          },
          {} as Record<string, string>,
        ),
      },
    };
  };
